import React, { useEffect } from "react";
import BreadCrumb from "../../../../../Components/Common/BreadCrumb";
import SelectedTab from "../../../../../Components/Common/Tabs/SelectedTabs/SelectedTab";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader } from "reactstrap";
import Details from "./Details";
import { resetFormState } from "../../../../../slices/common/reducer";
import { changeActiveTab } from "../../../../../slices/team/roles/rolesSlice";
import { getEntityType } from "../../../../../Utils/CommonUtils";

const SelectedRoles = () => {
  const dispatch = useDispatch();
  const tabs = useSelector((state) => state.roles.selectedRoles.tabs);
  const activeTab = useSelector((state) => state.roles.selectedRoles.activeTab);

  const formState = useSelector((state) => state.common.formRendererState);
  const data = useSelector((state) => state.roles.selectedRoles.detailsData);
  const entityType = getEntityType();

  useEffect(() => {
    return () => {
      dispatch(resetFormState());
      dispatch(changeActiveTab("details"));
    };
  }, [dispatch]);

  const breadcrumbItems = [
    { title: "Team", link: "" },
    { title: "Role", link: "/team/role" },
    { title: `${data.code}`, link: "/team/role/update" },
  ];

  return (
    <>
      <div className="page-content">
        <BreadCrumb items={breadcrumbItems} />
        <Card className="details-wrapper">
          <CardHeader>
            <SelectedTab
              tabs={tabs}
              activeTab={activeTab}
              changeActiveTab={changeActiveTab}
            />
          </CardHeader>
          {activeTab === "details" && <Details />}
        </Card>
      </div>
    </>
  );
};

export default SelectedRoles;
